<!--
 * @Description: (弹框)商户详情组件
 * @Author: sunhuihong
 * @Date: 2022-09-29 16:43:52
 * @LastEditTime: 2022-11-08 14:46:59
-->
<template>
  <div class="body">
    <el-drawer title="收付通商户详情" :before-close="handleClose" :visible.sync="visible" direction="rtl" 
      size="1000px" ref="drawer" withHeader :wrapperClosable="wrapperClosable" :append-to-body="true" @open="getDetails">
      <common-mch-details :mchDetailsData="mchDetailsData"/>
    </el-drawer>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import CommonMchDetails from './CommonMchDetails.vue'

export default { 
  name: 'MchDetails',
  props: ["visible", "mchId"],
  components: {
    'common-mch-details': CommonMchDetails
  },

  data() {
    return {
      wrapperClosable: true,
      mchDetailsData: {},
    }
  },
  
  methods: { 
    getDetails() {
      let params = {id: this.mchId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_MERCHANT,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.mchDetailsData = result.data;
      })
    },

    handleClose() {
      this.$emit("close-drawer", false);
    }
  },
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/mchmng/components/MchDetails.vue